import uiI18n from "../i18n";
import { apiFetch } from "./apiClient";

export async function downloadPdf(type, id) {
  if (!["property", "vacation"].includes(type) || !id) throw new Error(uiI18n.t("ui.invalid_listing"));
  const response = await apiFetch(`print/${type}/${encodeURIComponent(id)}`, { authenticated: false });
  if (!response.headers.get("content-type")?.includes("application/pdf")) throw new Error(uiI18n.t("ui.the_server_did_not_return_a_pdf"));
  const url = URL.createObjectURL(await response.blob());
  const link = document.createElement("a");
  link.href = url;
  link.download = `lina-immo-${type}-${id}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
